import { ENDKONTROLLMESSSTELLE, messstellentypIdToObj } from "../consts/messstellentyp";
import routes from "../consts/routes.json";
import { statusOptionen } from "../consts/valueLists";
import {
    errorMessage,
    requiredDate,
    requiredEnumWerteListeObjekt,
    requiredString,
    requiredWerteListeObjekt
} from "../utils/Validator";
import { createInitialLage, createLageSchema } from "./Lage";
import Joi from "joi";

export const createInitialMessstelle = (typ) => {
    let einleitstelle = {};
    if (typ === ENDKONTROLLMESSSTELLE) {
        einleitstelle = {
            einleitstelle: {
                lage: createInitialLage(),
                teileinzugsgebiet: null,
                oberflaechenwasserkoerper: null,
                pegel: null,
                einleitungMnq: null,
                einleitungMq: null,
            },
        };
    }
    return {
        bezeichnung: null,
        messstellentyp: messstellentypIdToObj(typ),
        messstellenstatus: statusOptionen[0],
        abgabeRelevant: false,
        frachtRelevant: false,
        waermeRelevant: false,
        lage: createInitialLage(),
        anhang: createInitialAnhangObject(),
        ...einleitstelle,
    };
};

export const createInitialMindestanforderung = () => {
    return {};
};

export const createInitialVorbelastung = () => {
    return {};
};

export const createVorbelastungSchema = () => {
    return {
        gueltigAb: requiredDate(),
    };
};

export const createMessstelleSchema = () => {
    return {
        bezeichnung: requiredString(),
        messstellentyp: requiredEnumWerteListeObjekt(),
        lage: createLageSchema(),
        anhang: createAnhangObject(),
        suggestedId: {
            frei: requiredString()
                .length(2)
                .pattern(/^\d+$/)
                .error((tmpErrors) => {
                    tmpErrors[0].message = "Es müssen genau zwei Ziffern angegeben werden!";
                    return tmpErrors[0];
                }),
        },
    };
};

export const createEinleitstelleSchema = () => {
    return {
        einleitstelle: {
            lage: createLageSchema(),
        },
    };
};

export const createInitialAnhangObject = () => {
    return {
        anhangAbwasserverordnung: null,
        abwasserart: null,
    };
};

const createAnhangObject = () => {
    return errorMessage(
        Joi.alternatives().try(
            Joi.object({
                anhangAbwasserverordnung: requiredWerteListeObjekt(),
                abwasserart: requiredWerteListeObjekt(),
            }),
            Joi.object({
                anhangAbwasserverordnung: Joi.object().allow(null).valid(null),
                abwasserart: Joi.object().allow(null).valid(null),
            })
        ),
        'Die Felder "Anhang AbwV" und "Abwasserart" müssen entweder beide leer oder befüllt sein!'
    );
};

export function calculateMessstelleLink(messstelle, modus = "l") {
    const betriebId = messstelle?.abwasseranlage?.betrieb?.id;
    let pfad = `${routes.BETRIEBSAKTE_RAW}/${betriebId}`;

    // Aufnehmende Entlastungsanlagen sind "Subanlagen" und haben
    // daher einen anderen Pfad zu den Messstellen als normale Anlagen
    const aufnehmendeAnlage = messstelle?.abwasseranlage?.aufnahme;
    const isAufnehmendeAnlageEntlastung = messstelle?.abwasseranlage?.anlagentyp?.id === "ENTLASTUNG";
    if (aufnehmendeAnlage && isAufnehmendeAnlageEntlastung) {
        const anlageTypId = messstelle?.abwasseranlage?.anlagentyp?.id?.toLowerCase();
        pfad = `${pfad}/${anlageTypId}`;
    }

    const abwasseranlageId = messstelle?.abwasseranlage?.id;
    const messstelleId = messstelle.id;
    return `${pfad}/${abwasseranlageId}/messstellen/${messstelleId}/messstellendaten?modus=${modus}`;
}

export function calculateFirstLevelEntlastungsanlageMessstelleLink(messstelle, modus = "l") {
    const betriebId = messstelle?.abwasseranlage?.betrieb?.id;
    const abwasseranlageId = messstelle?.abwasseranlage?.id;
    const messstelleId = messstelle.id;
    const basePfad = `${routes.BETRIEBSAKTE_RAW}/${betriebId}`;
    return `${basePfad}/${abwasseranlageId}/messstellen/${messstelleId}/messstellendaten?modus=${modus}`;
}
